<template>
  <v-app-bar
    id="top-nav"
    app
    :color="dark ? 'primary' : undefined"
    :class="{ 'top-nav--dark': dark, 'top-nav--light': !dark }"
  >

    <v-app-bar-nav-icon
      @click.stop="$store.toggleSideNavOpen()"
    />

    <v-toolbar-title>{{ title }}</v-toolbar-title>

    <template v-slot:append>
      <slot name="append-extra" />
      <account-icon class="ml-4" :progressCircleColor="$vuetify.theme.current.colors.primaryLight" />
    </template>

    <template v-if="$slots.extension" v-slot:extension>
      <slot name="extension" />
    </template>

  </v-app-bar>
</template>

<script>
import { AccountIcon } from "vue-app-components";

export default {
  components: {
    AccountIcon
  },
  props: {
    title: {
      type: String,
      default: "FoosMonster"
    },
    dark: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="css" scoped>

#top-nav {
  padding-left: 2px;
  padding-right: 20px;
}

#top-nav :deep(.account-icon .account-icon__icon .v-icon) {
  background-image: url("/favicon-32x32.png");
  background-size: 88% 88%;
  background-repeat: no-repeat;
  background-position: 51.5% 30%;
}

#top-nav :deep(.account-icon .account-icon__icon .v-icon::before) {
  content: none;
}

</style>
